import React from 'react';
import { useQuery } from '@apollo/client';
import QUERY_QUIZ from '../../graphql/query/quiz/allAvailableQuiz';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { QuizDef } from '../../types/quiz/quiz.def';
import { useRefetchData } from '../../helpers/refetch/refetchData';
import QuizzesView from './Quizzes.view';
import { AllAvailableQuizzQuery } from '../../graphql/generated/graphql';
import { ToRequiredType } from '../../types/typeDef';
import { useHistory } from 'react-router-dom';
import { getGoToPage } from '../../helpers/page/goToPage';

const Quizzes = () => {
  const { loading, error, data, refetch } = useQuery<AllAvailableQuizzQuery>(
    QUERY_QUIZ
  );

  useRefetchData(refetch);
  const history = useHistory();
  const onNavigate = getGoToPage<{ id: QuizDef['id'] }>(history);

  if (loading) return <LoadingLayout />;
  if (error)
    return (
      <ErrorContainer
        detailErr={error}
        text={'Erreur aux chargement des quiz, veuillez recharger la page'}
      />
    );

  return (
    <QuizzesView
      availableQuiz={data.availableQuiz as ToRequiredType<QuizDef>[]}
      onNavigate={onNavigate}
    />
  );
};

export default Quizzes;
